import { render, staticRenderFns } from "./NotificationsStopBrigade.vue?vue&type=template&id=f5c06860&"
import script from "./NotificationsStopBrigade.vue?vue&type=script&lang=js&"
export * from "./NotificationsStopBrigade.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsStopBrigade.vue?vue&type=style&index=0&id=f5c06860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports